export default "__VITE_ASSET__YLURHCKf__"